import {createSlice, createAsyncThunk, current} from "@reduxjs/toolkit";
import { api } from "../../api/httpclient";

const defaultFormInitialValues = {
    entityType: "",
    title: "",
    navigate: true
};

const initialState = {
    processing: false, 
    processingText: "",
    formKey: (new Date()).toString(), 
    formInitialValues: {...defaultFormInitialValues}, 
    formValues: {...defaultFormInitialValues}
};


const entityClonerSlice = createSlice({
    name: "entityCloner",
    initialState: initialState,
    reducers:{
        setProcessing: (state, action) => {
            //payload: {processing=true, processingText=false}, when processing is false, processingText is "" 
            const {processing=true, processingText=""} = action.payload;

            return ({...state, processing: processing, processingText: processing==false ? "" : processingText});
        },

        initEntityCloner: (state, action) =>  {
            let title = action.payload.title;
            let navigate = action.payload.navigate;
            
            return ({
                ...state, 
                formKey: (new Date()).toString(), 
                formInitialValues: {title: title, navigate: navigate},
                formValues: {title: title, navigate: navigate}
            })
        },

        setTitle: (state, action) => ({...state, formValues:{ ...state.formValues, title: action.payload}}),

        setNavigate: (state, action) => ({...state, formValues:{ ...state.formValues, navigate: action.payload}})
    }
});


export default entityClonerSlice.reducer;


export const cloneExpression = (t) => async (dispatch, getState) => {
    const state = getState().entityCloner;

    //if processing reject with ignore where the client caller just does nothing
    if (state.processing)
        return Promise.reject("ignore");

    const pageState = getState().expressionsPage;

    let id = pageState.formValues.Id;
    let title = state.formValues.title;
    let navigate = state.formValues.navigate;

    //make sure title is not empty
    if (!title || title.trim().length == 0)    
        return Promise.reject("invalidData");    


    //show loader
    dispatch(setProcessing({processing: true, processingText: t("slices.cloningExpression")}));

    try{
        var response = await api({            
            url: "/expression/cloneexpression",
            method:  'post',
            data: {title: title, id: id },
            //headers:{'h':'1'}
        });


        //success
        let data = response.data.Data;

        dispatch(setProcessing({processing: false}));

        return Promise.resolve({id: data.Id, title: title, navigate: navigate});
    }
    catch(err)
    {
        dispatch(setProcessing({processing: false}));

        return Promise.reject(err);
    }
};

export const cloneDataSource = (t) => async (dispatch, getState) => {
    const state = getState().entityCloner;

    //if processing reject with ignore where the client caller just does nothing
    if (state.processing)
        return Promise.reject("ignore");

    const pageState = getState().dataSourcesPage;

    let id = pageState.formValues.Id;
    let title = state.formValues.title;
    let navigate = state.formValues.navigate;

    //make sure title is not empty
    if (!title || title.trim().length == 0)    
        return Promise.reject("invalidData");    


    //show loader
    dispatch(setProcessing({processing: true, processingText: t("slices.cloningDataSource")}));

    try{
        var response = await api({            
            url: "/datasource/clonedatasource",
            method:  'post',
            data: {title: title, id: id },
            //headers:{'h':'1'}
        });


        //success
        let data = response.data.Data;

        dispatch(setProcessing({processing: false}));

        return Promise.resolve({id: data.Id, title: title, navigate: navigate});
    }
    catch(err)
    {
        dispatch(setProcessing({processing: false}));

        return Promise.reject(err);
    }
};

export const cloneAlert = (t) => async (dispatch, getState) => {
    const state = getState().entityCloner;

    //if processing reject with ignore where the client caller just does nothing
    if (state.processing)
        return Promise.reject("ignore");

    const pageState = getState().alertsPage;

    let id = pageState.formValues.Id;
    let title = state.formValues.title;
    let navigate = state.formValues.navigate;

    //make sure title is not empty
    if (!title || title.trim().length == 0)    
        return Promise.reject("invalidData");    


    //show loader
    dispatch(setProcessing({processing: true, processingText: t("slices.cloningAlert")}));

    try{
        var response = await api({            
            url: "/alert/clonealert",
            method:  'post',
            data: {title: title, id: id },
            //headers:{'h':'1'}
        });


        //success
        let data = response.data.Data;

        dispatch(setProcessing({processing: false}));

        return Promise.resolve({id: data.Id, title: title, navigate: navigate});
    }
    catch(err)
    {
        dispatch(setProcessing({processing: false}));

        return Promise.reject(err);
    }
};


export const cloneReport = (t) => async (dispatch, getState) => {
    const state = getState().entityCloner;

    //if processing reject with ignore where the client caller just does nothing
    if (state.processing)
        return Promise.reject("ignore");


    const reportingDesignPageState = getState().reportingDesignPage;

    let reportId = reportingDesignPageState.reportId;
    let title = state.formValues.title;
    let navigate = state.formValues.navigate;

    //make sure title is not empty
    if (!title || title.trim().length == 0)    
        return Promise.reject("invalidData");    


    //show loader
    dispatch(setProcessing({processing: true, processingText: t("slices.cloningReport")}));

    try{
        var response = await api({            
            url: "/reportingdesign/clonereport",
            method:  'post',
            data: {title: title, id: reportId },
            //headers:{'h':'1'}
        });


        //success
        let data = response.data.Data;

        dispatch(setProcessing({processing: false}));

        return Promise.resolve({referenceKey: data.ReferenceKey, navigate: navigate});
    }
    catch(err)
    {
        dispatch(setProcessing({processing: false}));

        return Promise.reject(err);
    }
};


export const { setProcessing, initEntityCloner, setTitle, setNavigate } = entityClonerSlice.actions;

    